import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdErrListTrms = () => {
    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchDateCls: 'indt',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchType: '',
        searchGubun: '',
        // validationCheckList: ['searchEmog']
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = ['번호', '기관명', '등록번호', '내원일자', '내원시간', '오류일자', '오류시간', '구분', '내용', '상태']; //component화 
    const dataColumn = ['SEQ', 'EMOGDESC', 'PTMIIDNO', 'ERROINDT', 'ERROINTM', 'ERROWRDT', 'ERROWRTM', 'ERROGUBN', 'ERRODESC', 'ERROFLAG'];
    const apiCall = '/ptmiapi/gumto/bderrlist_search.do';
    const apiCntCall = '/ptmiapi/gumto/bderrlist_cnt.do';
    const searchParamsAdditional = { searchGubunS: "" };
    const excelFileName = '오류내역';
    const excelHead = [];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['5%', '11%', '8%', '8%', '5%', '8%', '5%', '10%', '20%', '10%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: true,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={true}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                        </tr>
                        <tr>
                            <th>상태</th>
                            <td>
                                <select
                                    id="searchType"
                                    name="searchType"
                                    className='w-full'
                                    value={searchParams.searchType}
                                    onChange={handleInputChange}
                                >
                                    <option value="%">전체</option>
                                    <option value="Y">오류</option>
                                    <option value="N">오류해소</option>
                                    <option value="D">삭제</option>
                                </select>
                            </td>
                            <th>오류범위</th>
                            <td>
                                <select
                                    id="searchGubun"
                                    name="searchGubun"
                                    className='w-full'
                                    value={searchParams.searchGubun}
                                    onChange={handleInputChange}
                                >
                                    <option value="%">전체</option>
                                    <option value="PTMI">표준응급정보</option>
                                    <option value="KCPR">심정지정보1.0</option>
                                    <option value="SCPR">심정지정보2.0</option>
                                    <option value="TRMS">외상정보</option>
                                    <option value="KAMI">응급심장질환정보</option>
                                    <option value="KCVA">응급뇌질환정보</option>
                                    <option value="STRM">중증외상정보</option>
                                </select>
                            </td>
                            <th>등록번호</th>
                            <td>
                                <input
                                    type="text"
                                    id="searchIdno"
                                    name="searchIdno"
                                    value={searchParams.searchIdno}
                                    onChange={handleInputChange}
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>
                                <select
                                    id="searchDateCls"
                                    name="searchDateCls"
                                    value={searchParams.searchDateCls}
                                    onChange={handleInputChange}
                                >
                                    <option value="indt">내원일자</option>
                                    <option value="wrdt">전송일자</option>
                                </select>
                            </th>
                            <td colSpan={5}>
                                <input
                                    type="date"
                                    name="searchFromdate"
                                    value={searchParams.searchFromdate}
                                    onChange={handleInputChange}
                                    className="calendar width_70"
                                />
                                &nbsp;~&nbsp;
                                <input
                                    type="date"
                                    name="searchTodate"
                                    value={searchParams.searchTodate}
                                    onChange={handleInputChange}
                                    min={searchParams.searchFromdate}
                                    className="calendar width_70"
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <p>* 각 병원에 배포되어진 KTDB Agent가 중앙서버로 환자정보를 전송할 때 발생한 오류를 확인합니다. 오류원인 확인 후 수정하셔서 재전송해주세요.</p>
            <p>* 매일 새벽 1시에 중앙서버에서 자동으로 오류 갱신합니다.</p>
        </Main>
    )
}

export default BdErrListTrms;